export default __webpack_public_path__ + "static/media/Empty-cart.5f3c678b.png";